import { Directive, TemplateRef, inject } from '@angular/core';

import { BaseComponent } from '../base/base.component';

/** The template context of a slide declared via `*immoSwiperSlide`. */
export interface SwiperSlideContext {
    /** The zero-based index of the slide within the swiper. */
    $implicit: number;
}

/**
 * Declares a slide template inside `<immo-swiper>`:
 *
 * `<ng-template immoSwiperSlide let-index>…</ng-template>`
 *
 * The component wraps each template in a `<swiper-slide>` element itself, so consumers of
 * `<immo-swiper>` never need `CUSTOM_ELEMENTS_SCHEMA` in their own component.
 */
@Directive({
    selector: 'ng-template[immoSwiperSlide]',
})
export class SwiperSlideDirective extends BaseComponent {
    // -----------------------------------------------------------------------------------------------------
    // @ DEPENDENCIES
    // -----------------------------------------------------------------------------------------------------

    readonly templateRef: TemplateRef<SwiperSlideContext> = inject(TemplateRef);

    // -----------------------------------------------------------------------------------------------------
    // @ PUBLIC METHODS
    // -----------------------------------------------------------------------------------------------------

    /**
     * Type guard enabling the correct template context type for `let-` bindings.
     *
     * @param directive - The directive instance.
     * @param context - The template context to narrow.
     * @returns {boolean} Always true; the signature alone carries the type information.
     */
    static ngTemplateContextGuard(directive: SwiperSlideDirective, context: unknown): context is SwiperSlideContext {
        return true;
    }
}
